import { SectionMeta, MarketWave, ToolModuleSpec, DatabaseTable } from '../types';

export const SECTIONS_META: SectionMeta[] = [
  {
    id: 'vision',
    letter: 'A',
    titleFr: 'Vision Produit Définitive',
    titleEn: 'Definitive Product Vision',
    badge: 'Core Identity',
    summary: 'YamooPay en tant qu\'autorité mondiale de Financial Intelligence et d\'outils financiers universels.',
  },
  {
    id: 'positioning',
    letter: 'B',
    titleFr: 'Positionnement Mondial & Neutralité',
    titleEn: 'Global Positioning & Neutrality',
    badge: 'Market Positioning',
    summary: 'Neutralité internationale absolue, standards fintech suisses/américains, élimination des biais régionaux par défaut.',
  },
  {
    id: 'personas',
    letter: 'C',
    titleFr: 'Personas Internationaux',
    titleEn: 'International Personas',
    badge: 'User Archetypes',
    summary: '6 profils clés : Expatriés, Salariés US/EU/Global, Freelances transfrontaliers, Investisseurs, Emprunteurs, Familles.',
  },
  {
    id: 'markets',
    letter: 'D',
    titleFr: 'Segmentation par Marché (Waves 1 à 5)',
    titleEn: 'Market Waves Strategy',
    badge: 'Expansion Strategy',
    summary: 'Déploiement ordonné : Wave 1 (North America), Wave 2 (Europe), Wave 3 (APAC), Wave 4 (LatAm/ME), Wave 5 (Africa).',
  },
  {
    id: 'value-prop',
    letter: 'E',
    titleFr: 'Proposition de Valeur Unique (UVP)',
    titleEn: 'Unique Value Proposition',
    badge: 'Value Engine',
    summary: 'Précision mathématique vérifiable, absence de biais d\'affiliation dissimulé, rapidité instantanée, clarté pédagogique.',
  },
  {
    id: 'modules',
    letter: 'F',
    titleFr: 'Analyse Détaillée des 18+ Modules',
    titleEn: 'Detailed Module Specifications',
    badge: 'Engine Catalog',
    summary: 'Spécifications complètes des moteurs de change, salaires, prêts, transferts, inflation et fiscalité.',
  },
  {
    id: 'functional-arch',
    letter: 'G',
    titleFr: 'Architecture Fonctionnelle Globale',
    titleEn: 'Functional Architecture',
    badge: 'System Topology',
    summary: 'Orchestration modulaire : Calculateurs, Trust Layer, Data Governance, Rules Engines et Auth Layer.',
  },
  {
    id: 'information-arch',
    letter: 'H',
    titleFr: 'Architecture de l\'Information (IA)',
    titleEn: 'Information Architecture',
    badge: 'Hierarchy & Flow',
    summary: 'Structure arborescente sans friction, maillage thématique par intention, juridiction et devise.',
  },
  {
    id: 'navigation',
    letter: 'I',
    titleFr: 'Navigation Principale & Command Bar',
    titleEn: 'Main Navigation & Command Bar',
    badge: 'UX Navigation',
    summary: 'Command Bar universelle "What do you want to calculate?", Sélecteur Région/Devise/Langue persistant.',
  },
  {
    id: 'regional-arch',
    letter: 'J',
    titleFr: 'Architecture Region Pack',
    titleEn: 'Region Pack Architecture',
    badge: 'Modularity',
    summary: 'GlobalCore + NorthAmericaPack, EuropePack, AsiaPacificPack, MiddleEastPack, LatinAmericaPack, AfricaPack.',
  },
  {
    id: 'linguistic-arch',
    letter: 'K',
    titleFr: 'Architecture Linguistique & i18n',
    titleEn: 'Linguistic & Localization Engine',
    badge: 'i18n / l10n',
    summary: 'Anglais comme langue pivot globale, fallback hiérarchique, isolation des clés et formateurs régionaux Intl.',
  },
  {
    id: 'seo-arch',
    letter: 'L',
    titleFr: 'Architecture SEO Internationale & Quality Gate',
    titleEn: 'Global SEO & Quality Gate',
    badge: 'Organic Search',
    summary: 'Hreflang explicites (en-US, en-GB, fr-FR...), URLs déterministes, Schema.org strict, barrière qualité anti-thin content.',
  },
  {
    id: 'design-system',
    letter: 'M',
    titleFr: 'Principes du Design System (Light Mode Only)',
    titleEn: 'Design System & Visual Craft',
    badge: 'Light Mode Exclusive',
    summary: 'Palette blanche/ardoise/bleu YamooPay, typographie à fort contraste, mathématique d\'espacement, 0% AI slop.',
  },
  {
    id: 'homepage-structure',
    letter: 'N',
    titleFr: 'Structure & Hiérarchie de la Homepage',
    titleEn: 'Homepage Structural Layout',
    badge: 'Landing Craft',
    summary: 'Hero international sobre, 4 piliers d\'accès immédiats, zéro bannière intrusive above-the-fold, trust layer.',
  },
  {
    id: 'tech-arch',
    letter: 'O',
    titleFr: 'Architecture Technique Cible (Stack 2026)',
    titleEn: 'Target Technical Stack 2026',
    badge: 'Engineering',
    summary: 'Next.js 16 / React 19, TypeScript Strict, Tailwind CSS, PostgreSQL, Docker, Dokploy sur Hostinger VPS.',
  },
  {
    id: 'data-model',
    letter: 'P',
    titleFr: 'Modèle Conceptuel des Données (PostgreSQL)',
    titleEn: 'Conceptual Data Model',
    badge: 'PostgreSQL Schema',
    summary: '28+ tables relationnelles versionnées : TaxRules, Currencies, ExchangeRates, Quotes, LoanScenarios, AuditLogs.',
  },
  {
    id: 'data-reliability',
    letter: 'Q',
    titleFr: 'Stratégie de Fiabilité & Data Governance',
    titleEn: 'Data Reliability & Governance',
    badge: 'Data Ops',
    summary: 'Multi-sources FX, horodatage transparent, détection d\'anomalies, alerting Stale/Failed, reproductibilité fiscale.',
  },
  {
    id: 'security-compliance',
    letter: 'R',
    titleFr: 'Sécurité, Conformité & Confidentialité',
    titleEn: 'Security, Privacy & Compliance',
    badge: 'OWASP / GDPR',
    summary: 'OWASP Top 10, CSP stricte, Consent Manager régionalisé (RGPD/CCPA/Loi 25), calculs côté client sans fuite de données.',
  },
  {
    id: 'monetization',
    letter: 'S',
    titleFr: 'Stratégie Publicitaire & Affiliation Éthique',
    titleEn: 'Monetization & Ethical Affiliate',
    badge: 'Revenue Engine',
    summary: 'Abstraction AdProvider (AdSense/Ezoic), isolation CLS, User Value Score distinct du Commercial Score, labels clairs.',
  },
  {
    id: 'backlog',
    letter: 'T',
    titleFr: 'Backlog Priorisé P0 / P1 / P2 / P3',
    titleEn: 'Prioritized Backlog',
    badge: 'Product Backlog',
    summary: 'Matrice de priorisation d\'ingénierie et de déploiement progressif des moteurs et modules régionaux.',
  },
  {
    id: 'roadmap',
    letter: 'U',
    titleFr: 'Roadmap Complète de Construction (20 Livrables)',
    titleEn: 'Master 20-Step Roadmap',
    badge: 'Execution Plan',
    summary: 'Les 20 phases méthodiques de la reconstruction totale de YamooPay jusqu\'au déploiement mondial continu.',
  },
  {
    id: 'acceptance-criteria',
    letter: 'V',
    titleFr: 'Critères d\'Acceptation Globaux',
    titleEn: 'Global Acceptance Criteria',
    badge: 'Quality Standard',
    summary: 'Standards non négociables de précision fiscale, performance Web Vitals, conformité WCAG 2.2 AA et intégrité SEO.',
  },
  {
    id: 'risks-mitigation',
    letter: 'W',
    titleFr: 'Matrice des Risques & Mesures de Mitigation',
    titleEn: 'Risk Matrix & Mitigation',
    badge: 'Risk Governance',
    summary: 'Obsolescence des taux/taxes, pénalités SEO thin-content, latence multi-régions, dérive de positionnement.',
  },
  {
    id: 'ux-spec-p2',
    letter: 'P2-A',
    titleFr: 'Design System & Spécifications UX (Prompt 02)',
    titleEn: 'Design System & UX Specifications (Prompt 02)',
    badge: 'Light Mode Archetype',
    summary: 'Spécification complète du design system 100% Light Mode, tokens typographiques et architecture visuelle.',
  },
  {
    id: 'tokens-p2',
    letter: 'P2-B',
    titleFr: 'Tokens de Design & Variables CSS (Prompt 02)',
    titleEn: 'Design Tokens & CSS Variables (Prompt 02)',
    badge: 'Design Tokens',
    summary: 'Définition exacte des variables de couleurs neutres saturées, contrastes WCAG AA et échelle modulaire.',
  },
  {
    id: 'data-governance-p3',
    letter: 'P3-A',
    titleFr: 'Gouvernance des Données Financières (Prompt 03)',
    titleEn: 'Financial Data Governance Engine (Prompt 03)',
    badge: 'Data Trust Center',
    summary: 'Protocoles de vérification, multi-source aggregation, circuit breakers et observabilité des flux financiers.',
  },
  {
    id: 'postgres-schema-p3',
    letter: 'P3-B',
    titleFr: 'Schéma PostgreSQL 18 & DDL Tables (Prompt 03)',
    titleEn: 'PostgreSQL 18 Relational Schema & DDL (Prompt 03)',
    badge: 'Database Architecture',
    summary: 'DDL relationnel complet, audit trail, horodatage immutables et contraintes d\'intégrité référentielle.',
  },
  {
    id: 'fx-intelligence-p4',
    letter: 'P4',
    titleFr: 'Moteur de Change & Currency Intelligence (Prompt 04)',
    titleEn: 'Global Currency Intelligence Engine (Prompt 04)',
    badge: 'FX Intelligence',
    summary: '170+ devises mondiales, agrégation multi-sources, taux benchmark mid-market et conversion financière haute précision.',
  },
  {
    id: 'money-transfers-p5',
    letter: 'P5',
    titleFr: 'Moteur d\'Agrégation des Transferts Internationaux (Prompt 05)',
    titleEn: 'Money Transfer Intelligence Engine (Prompt 05)',
    badge: 'Remittance Engine',
    summary: 'Comparateur de transferts internationaux, détection de markups FX dissimulés, calcul du coût total et corridors mondiaux.',
  },
  {
    id: 'salary-engine-p6',
    letter: 'P6',
    titleFr: 'Moteur Mondial de Salaires, Paie & Fiscalité (Prompt 06)',
    titleEn: 'Global Salary, Paycheck & Income Tax Engine (Prompt 06)',
    badge: 'Payroll Intelligence',
    summary: 'Calculateur brut-vers-net, solveur inverse net-vers-brut, coût employeur, règles fiscales versionnées 2026 et explicabilité.',
  },
  {
    id: 'loan-engine-p7',
    letter: 'P7',
    titleFr: 'Moteur Mondial de Prêts, Hypothèques & Crédit (Prompt 07)',
    titleEn: 'Global Loan, Mortgage & Credit Intelligence Engine (Prompt 07)',
    badge: 'Lending Intelligence',
    summary: 'Calculateur d’échéancier, composition souveraine, PITI, APR/APRC/TAEG, remboursements anticipés, capacité d’emprunt et rachat de crédit.',
  },
  {
    id: 'identity-security-p8',
    letter: 'P8',
    titleFr: 'Identité Mondiale, Sécurité & Espace Personnel My YamooPay (Prompt 08)',
    titleEn: 'YamooPay Global Identity, Account Security & Personal Workspace Engine (Prompt 08)',
    badge: 'Identity & Security',
    summary: 'Passkeys WebAuthn, connexion OIDC (Google/Apple/Microsoft), sessions serveur, mode sudo step-up, espace personnel My YamooPay, scénarios, alertes, centre de confidentialité et RBAC.',
  },
  {
    id: 'seo-growth-p9',
    letter: 'P9',
    titleFr: 'Moteur Mondial de Croissance Organique, SEO & CMS Éditorial (Prompt 09)',
    titleEn: 'YamooPay Global Organic Growth, Programmatic SEO & Financial CMS Engine (Prompt 09)',
    badge: 'Organic Search & CMS',
    summary: 'Gouvernance YMYL, auteurs/revoyeurs vérifiés E-E-A-T, CMS financier avec workflow, garde-fou d’indexabilité, graphe hreflang, Search Console intelligence et registre Schema.org.',
  },
  {
    id: 'monetization-p10',
    letter: 'P10',
    titleFr: 'Moteur Mondial de Monétisation & Intelligence Revenu YamooPay (Prompt 10)',
    titleEn: 'YamooPay Global Monetization & Revenue Intelligence Engine (Prompt 10)',
    badge: 'Monetization & Ad Intelligence',
    summary: 'Google AdSense, Ezoic, revenus d’affiliation, gestion des consentements TCF v2.2 & GPP, inventaire publicitaire, zones de calcul protégées, intelligence RPM/EPMV et pare-feu d’indépendance du classement.',
  },
  {
    id: 'analytics-p11',
    letter: 'P11',
    titleFr: 'Moteur Mondial d\'Analytics Produit & Business Intelligence YamooPay (Prompt 11)',
    titleEn: 'YamooPay Global Product Analytics & Business Intelligence Engine (Prompt 11)',
    badge: 'Product Analytics & Executive BI',
    summary: 'Taxonomie d\'événements typée, anonymisation et scrubber de données financières, first-party analytics collector, routage GA4, entonnoirs de conversion, cohortes de rétention, attribution et centre de commandement exécutif.',
  },
  {
    id: 'growth-p12',
    letter: 'P12',
    titleFr: 'Moteur Mondial de Growth, CRM & Lifecycle Marketing YamooPay (Prompt 12)',
    titleEn: 'YamooPay Global Growth, CRM & Lifecycle Intelligence Engine (Prompt 12)',
    badge: 'Growth, CRM & Lifecycle',
    summary: 'Cœur CRM non-sensible, 10 étapes de cycle de vie utilisateur, segmentation avec garde-fou de confidentialité, parcours de campagnes automatisés, adaptateur d\'emails avec isolation des flux, SPF/DKIM/DMARC, parrainage authentique et Growth Command Center.',
  },
  {
    id: 'wealth-intelligence-p13',
    letter: 'P13',
    titleFr: 'Moteur Mondial d\'Épargne, Retraite & Intelligence Patrimoniale YamooPay (Prompt 13)',
    titleEn: 'YamooPay Global Savings, Retirement & Wealth Intelligence Engine (Prompt 13)',
    badge: 'Savings, FIRE & Retirement',
    summary: 'Calculateur d\'intérêt composé, valeur future, valeur présente, rendement réel multiplicatif, indices d\'inflation officiels (BLS, StatCan, ONS, Eurostat, ABS), solveur de projets d\'épargne, projection FIRE/Retraite (Accumulation & Décaisse), impact des frais, matrice multi-scénarios et Wealth Command Center.',
  },
  {
    id: 'everyday-calculator-p14',
    letter: 'P14',
    titleFr: 'Moteur Mondial de Gestion Quotidienne et Calculateur Universel YamooPay (Prompt 14)',
    titleEn: 'YamooPay Global Everyday Money & Universal Calculator Intelligence Engine (Prompt 14)',
    badge: 'Everyday & Universal Calculators',
    summary: 'Moteur déterministe universel couvrant pourcentages, remises, marges, majorations, profits, TVA/TPS, pourboires, partage d\'addition, heures de travail, heures supplémentaires, coûts de carburant et d\'électricité, conversion d\'unités, âges, différences de dates, IMC, calories, recherche intelligente et Calculator Command Center.',
  },
  {
    id: 'ai-financial-intelligence-p15',
    letter: 'P15',
    titleFr: 'Plateforme Globale IA, Recherche, Graphe de Connaissances & Intelligence Financière YamooPay (Prompt 15)',
    titleEn: 'YamooPay Global AI, Search, Knowledge Graph & Financial Intelligence Platform (Prompt 15)',
    badge: 'AI & Knowledge Orchestration',
    summary: 'Couche d\'orchestration intelligente (LLM comme orchestrateur et non comme moteur de calcul), moteur d\'intention, graphe de connaissances, recherche hybride, RAG de confiance, registre d\'outils sécurisés, moteurs de coût et de sécurité, plateformes d\'évaluation et Chief AI Officer Command Center.',
  },
];

export const MARKET_WAVES: MarketWave[] = [
  {
    wave: 1,
    name: 'Wave 1 — North America (Priority #1)',
    priority: 'Absolute Priority',
    strategicFocus: 'Établir la crédibilité éditoriale, SEO et technologique sur le marché financier le plus concurrentiel et à plus haut RPM.',
    currencies: ['USD', 'CAD'],
    countries: [
      {
        name: 'United States',
        code: 'US',
        currency: 'USD',
        locale: 'en-US / es-US',
        flag: '🇺🇸',
        tier: 'Tier 1',
        taxComplexity: 'Very High',
        notes: 'Système fédéral + 50 États + taxes locales. Règles W-4, FICA, Medicare, Standard/Itemized deductions.',
      },
      {
        name: 'Canada',
        code: 'CA',
        currency: 'CAD',
        locale: 'en-CA / fr-CA',
        flag: '🇨🇦',
        tier: 'Tier 1',
        taxComplexity: 'High',
        notes: 'Impôt fédéral CRA + 10 Provinces / 3 Territoires. CPP/QPP, EI, tranches progressives bilingues.',
      },
    ],
  },
  {
    wave: 2,
    name: 'Wave 2 — Europe (Western & Central)',
    priority: 'High',
    strategicFocus: 'Conquête des marchés majeurs multidevises européens (EUR, GBP, CHF) avec conformité RGPD intégrée dès la conception.',
    currencies: ['EUR', 'GBP', 'CHF'],
    countries: [
      { name: 'United Kingdom', code: 'GB', currency: 'GBP', locale: 'en-GB', flag: '🇬🇧', tier: 'Tier 1', taxComplexity: 'High', notes: 'HMRC PAYE, National Insurance (Class 1), Personal Allowance taper, Student Loan repayments.' },
      { name: 'France', code: 'FR', currency: 'EUR', locale: 'fr-FR', flag: '🇫🇷', tier: 'Tier 1', taxComplexity: 'Very High', notes: 'Brut/Net, Cotisations URSSAF (salarié/employeur), Prélèvement à la source, Quotient familial.' },
      { name: 'Germany', code: 'DE', currency: 'EUR', locale: 'de-DE', flag: '🇩🇪', tier: 'Tier 1', taxComplexity: 'Very High', notes: 'Steuerklasse (I à VI), Solidaritätszuschlag, Kirchensteuer, Krankenversicherung, Rentenversicherung.' },
      { name: 'Switzerland', code: 'CH', currency: 'CHF', locale: 'de-CH / fr-CH', flag: '🇨🇭', tier: 'Tier 1', taxComplexity: 'Very High', notes: 'Impôt fédéral direct + 26 Cantons + Communes. AVS/AI/APG, LPP (2e pilier), ALFA.' },
      { name: 'Spain', code: 'ES', currency: 'EUR', locale: 'es-ES', flag: '🇪🇸', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'IRPF barème étatique + autonomique, Seguridad Social (cotizaciones contingencias comunes).' },
      { name: 'Italy', code: 'IT', currency: 'EUR', locale: 'it-IT', flag: '🇮🇹', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'IRPEF national + addizionali regionali/comunali, INPS contributi previdenziali.' },
      { name: 'Netherlands', code: 'NL', currency: 'EUR', locale: 'nl-NL / en-NL', flag: '🇨🇵', tier: 'Tier 1', taxComplexity: 'High', notes: 'Box 1/2/3, 30% Ruling expatriates, ZVW, AOW pension contributions.' },
      { name: 'Belgium', code: 'BE', currency: 'EUR', locale: 'fr-BE / nl-BE', flag: '🇧🇪', tier: 'Tier 1', taxComplexity: 'High', notes: 'ONSS cotisations 13.07%, barème progressif fédéral + centimes additionnels communaux.' },
      { name: 'Ireland', code: 'IE', currency: 'EUR', locale: 'en-IE', flag: '🇮🇪', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'PAYE, Universal Social Charge (USC), PRSI (Class A).' },
      { name: 'Portugal', code: 'PT', currency: 'EUR', locale: 'pt-PT', flag: '🇵🇹', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'IRS barème annuel, Segurança Social (11% travailleur), retenues à la source mensuelles.' },
    ],
  },
  {
    wave: 3,
    name: 'Wave 3 — Asia-Pacific (Financial Hubs & Remittance Corridors)',
    priority: 'Strategic Expansion',
    strategicFocus: 'Hubs financiers à hauts revenus (Singapour, Hong Kong, Australie, Japon) + Grands récepteurs de transferts (Inde, Philippines).',
    currencies: ['SGD', 'HKD', 'AUD', 'NZD', 'JPY', 'INR', 'KRW', 'MYR', 'IDR', 'PHP'],
    countries: [
      { name: 'Singapore', code: 'SG', currency: 'SGD', locale: 'en-SG', flag: '🇸🇬', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'IRAS progressive rates, CPF (Central Provident Fund) employee/employer caps.' },
      { name: 'Australia', code: 'AU', currency: 'AUD', locale: 'en-AU', flag: '🇦🇺', tier: 'Tier 1', taxComplexity: 'High', notes: 'ATO PAYG, Superannuation Guarantee (11.5% - 12%), Medicare Levy (2%), HELP debt.' },
      { name: 'Japan', code: 'JP', currency: 'JPY', locale: 'ja-JP', flag: '🇯🇵', tier: 'Tier 1', taxComplexity: 'High', notes: 'National Income Tax + Resident Tax (Juminzei 10%), Shakai Hoken (Health, Pension, Employment).' },
      { name: 'India', code: 'IN', currency: 'INR', locale: 'en-IN / hi-IN', flag: '🇮🇳', tier: 'Tier 1', taxComplexity: 'Very High', notes: 'Old vs New Tax Regime (Section 115BAC), EPF, HRA, 80C exemptions, TDS, Remittance inbound leader.' },
      { name: 'Philippines', code: 'PH', currency: 'PHP', locale: 'en-PH', flag: '🇵🇭', tier: 'Tier 2', taxComplexity: 'Medium', notes: 'TRAIN Law withholding, SSS, PhilHealth, Pag-IBIG, corridor de transfert US/AU/ME majeur.' },
      { name: 'Hong Kong', code: 'HK', currency: 'HKD', locale: 'en-HK / zh-HK', flag: '🇭🇰', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'Salaries Tax (Progressive vs Standard 15%), MPF mandatory contribution.' },
      { name: 'South Korea', code: 'KR', currency: 'KRW', locale: 'ko-KR', flag: '🇰🇷', tier: 'Tier 1', taxComplexity: 'High', notes: 'Four Major Public Insurances (National Pension, Health, Long-term Care, Employment).' },
    ],
  },
  {
    wave: 4,
    name: 'Wave 4 — Middle East & Latin America',
    priority: 'Strategic Expansion',
    strategicFocus: 'Péninsule arabique (0% income tax, corridors sortants massifs) et Amérique Latine (volatilité des devises, inflation, prêts).',
    currencies: ['AED', 'SAR', 'QAR', 'MXN', 'BRL', 'COP', 'CLP', 'ARS'],
    countries: [
      { name: 'United Arab Emirates', code: 'AE', currency: 'AED', locale: 'en-AE / ar-AE', flag: '🇦🇪', tier: 'Tier 1', taxComplexity: 'Low', notes: '0% personal income tax, GPSSA pensions nationales, transfer hub #1 sortant.' },
      { name: 'Saudi Arabia', code: 'SA', currency: 'SAR', locale: 'ar-SA / en-SA', flag: '🇸🇦', tier: 'Tier 1', taxComplexity: 'Low', notes: 'GOSI social insurance, 0% personal tax, corridor transferts Asie/Afrique.' },
      { name: 'Mexico', code: 'MX', currency: 'MXN', locale: 'es-MX', flag: '🇲🇽', tier: 'Tier 1', taxComplexity: 'High', notes: 'ISR tabla mensual, IMSS cuotas obrero-patronales, corridor US -> MX #1 mondial.' },
      { name: 'Brazil', code: 'BR', currency: 'BRL', locale: 'pt-BR', flag: '🇧🇷', tier: 'Tier 1', taxComplexity: 'High', notes: 'IRRF tabela progressiva, INSS alíquotas progressivas, IOF sur opérations de change.' },
    ],
  },
  {
    wave: 5,
    name: 'Wave 5 — Africa Regional Pack',
    priority: 'Emerging High Growth',
    strategicFocus: 'Marché d\'avenir à fort potentiel démographique et mobile money, packagé de manière étanche via AfricaPack.',
    currencies: ['NGN', 'ZAR', 'KES', 'GHS', 'XAF', 'XOF', 'MAD', 'EGP', 'RWF', 'UGX', 'TZS'],
    countries: [
      { name: 'Nigeria', code: 'NG', currency: 'NGN', locale: 'en-NG', flag: '🇳🇬', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'PAYE PITA brackets, Pension 8%, NHF, FX multiple rates intelligence, Fintech corridor.' },
      { name: 'South Africa', code: 'ZA', currency: 'ZAR', locale: 'en-ZA', flag: '🇿🇦', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'SARS income tax table, Medical aid tax credits, UIF contributions.' },
      { name: 'Kenya', code: 'KE', currency: 'KES', locale: 'en-KE', flag: '🇰🇪', tier: 'Tier 1', taxComplexity: 'Medium', notes: 'KRA PAYE graduated bands, NSSF, NHIF/SHIF, Housing Levy, M-Pesa ecosystem.' },
      { name: 'Ghana', code: 'GH', currency: 'GHS', locale: 'en-GH', flag: '🇬🇭', tier: 'Tier 2', taxComplexity: 'Medium', notes: 'GRA PAYE brackets, Tier 1/2 SSNIT pension, E-Levy money transfers.' },
      { name: 'Morocco', code: 'MA', currency: 'MAD', locale: 'fr-MA / ar-MA', flag: '🇲🇦', tier: 'Tier 2', taxComplexity: 'Medium', notes: 'IR barème progressif, CNSS cotisations, AMO, corridor France/Europe -> Maroc.' },
      { name: 'Cameroon / Senegal / CI', code: 'CM/SN/CI', currency: 'XAF / XOF', locale: 'fr-CM / fr-SN / fr-CI', flag: '🌍', tier: 'Tier 2', taxComplexity: 'Medium', notes: 'Zones CEMAC/UEMOA, IRPP/ITS, CNPS/CSS, Mobile Money (Orange Money, MTN MoMo, Wave).' },
    ],
  },
];

export const TOOL_MODULES: ToolModuleSpec[] = [
  {
    id: 'currency-converter',
    nameFr: 'Convertisseur de Devises Intelligent',
    nameEn: 'Smart Currency Converter & FX Intelligence',
    category: 'Forex & Transfers',
    description: 'Conversion instantanée multidevises sur 170+ monnaies avec taux interbancaire certifié, horodatage transparent et graphiques historiques.',
    inputs: ['Montant', 'Devise Source (ex: USD)', 'Devise Cible (ex: EUR)', 'Date historique (optionnel)'],
    outputs: ['Taux interbancaire médian', 'Montant converti exact', 'Écart spread type banque', 'Tendance 24h / 30j / 1 an', 'Horodatage & Source'],
    dataSources: ['European Central Bank (ECB)', 'Bank of England', 'Federal Reserve', 'Open Financial APIs'],
    refreshRate: 'Temps réel / snapshots 60s',
    rulesetComplexity: 'Low',
    offlineCapability: true,
  },
  {
    id: 'transfer-comparison',
    nameFr: 'Comparateur de Transfert d\'Argent International',
    nameEn: 'International Money Transfer Comparison',
    category: 'Forex & Transfers',
    description: 'Comparaison impartiale et transparente des frais réels et des marges sur taux de change appliquées par les opérateurs mondiaux et régionaux.',
    inputs: ['Pays/Devise émetteur', 'Pays/Devise récepteur', 'Montant envoyé', 'Méthode de paiement', 'Méthode de réception'],
    outputs: ['Montant net reçu garanti', 'Frais fixes transparents', 'Coût caché sur le spread FX', 'Délai d\'acheminement estimé', 'User Value Score vs Commercial Score'],
    dataSources: ['APIs Directes Fournisseurs', 'Web Scrapers Certifiés', 'Devis instantanés vérifiés'],
    refreshRate: 'Snapshots toutes les 15 minutes',
    rulesetComplexity: 'Medium',
    offlineCapability: false,
  },
  {
    id: 'salary-tax-calculator',
    nameFr: 'Moteur Fiscal & Calculateur de Salaire 2.0',
    nameEn: 'Salary & Multi-Jurisdiction Tax Engine 2.0',
    category: 'Income & Payroll',
    description: 'Moteur de règles fiscales versionnées par pays, état/province/canton, année fiscale et statut marital pour un calcul Brut vers Net chirurgical.',
    inputs: ['Pays', 'Juridiction (État / Province / Canton)', 'Année fiscale (ex: 2026)', 'Salaire brut', 'Fréquence', 'Statut fiscal', 'Déductions'],
    outputs: ['Salaire Net après impôt', 'Impôt fédéral / national', 'Impôt régional / étatique', 'Cotisations sociales salariales', 'Cotisations patronales', 'Taux effectif vs Taux marginal'],
    dataSources: ['Codes Généraux des Impôts officiels', 'IRS / CRA / HMRC / URSSAF / IRAS tables officielles'],
    refreshRate: 'Annuel / semestriel avec versioning immuable',
    rulesetComplexity: 'Jurisdiction Versioned',
    offlineCapability: true,
  },
  {
    id: 'loan-mortgage-calculator',
    nameFr: 'Moteur de Prêt Immobilier & Amortissement',
    nameEn: 'Universal Loan & Mortgage Engine',
    category: 'Lending & Debt',
    description: 'Calcul des mensualités, TAEG/APR, tableau d\'amortissement complet mois par mois, impact des remboursements anticipés et coût global du crédit.',
    inputs: ['Capital emprunté', 'Taux d\'intérêt annuel (nominal / TAEG)', 'Durée (années / mois)', 'Assurance & frais annexes', 'Remboursements anticipés récurrents/ponctuels'],
    outputs: ['Mensualité tout compris', 'Coût total du crédit', 'Intérêts cumulés', 'Tableau d\'amortissement interactif', 'Économie générée par paiement anticipé'],
    dataSources: ['Formules mathématiques actuarielles certifiées'],
    refreshRate: 'Calcul instantané côté client',
    rulesetComplexity: 'Medium',
    offlineCapability: true,
  },
  {
    id: 'compound-interest-calculator',
    nameFr: 'Calculateur d\'Intérêts Composés & Épargne',
    nameEn: 'Compound Interest & Wealth Growth Calculator',
    category: 'Wealth & Inflation',
    description: 'Simulation de croissance patrimoniale à long terme avec versements réguliers, capitalisation (mensuelle/annuelle) et projection graphique.',
    inputs: ['Capital initial', 'Versement périodique', 'Taux de rendement attendu (%)', 'Durée de placement', 'Fréquence de capitalisation'],
    outputs: ['Capital final accumulé', 'Total versements effectués', 'Total intérêts générés', 'Courbe d\'évolution comparative', 'Ratio effet boule de neige'],
    dataSources: ['Algorithmes actuariels standardisés'],
    refreshRate: 'Instantané client',
    rulesetComplexity: 'Low',
    offlineCapability: true,
  },
  {
    id: 'inflation-purchasing-power',
    nameFr: 'Calculateur d\'Inflation & Pouvoir d\'Achat',
    nameEn: 'Inflation & Purchasing Power Simulator',
    category: 'Wealth & Inflation',
    description: 'Mesure l\'érosion monétaire réelle d\'un capital ou d\'un salaire dans le temps selon les indices officiels des prix à la consommation (CPI/IPC).',
    inputs: ['Montant de base', 'Année de départ', 'Année cible', 'Pays / Zone géographique (US, Eurozone, UK, etc.)'],
    outputs: ['Valeur corrigée de l\'inflation', 'Taux d\'inflation cumulé', 'Perte de pouvoir d\'achat en %', 'Équivalent salarial nécessaire'],
    dataSources: ['US Bureau of Labor Statistics (BLS)', 'Eurostat', 'ONS UK', 'World Bank CPI'],
    refreshRate: 'Mensuel à parution des indices',
    rulesetComplexity: 'Low',
    offlineCapability: true,
  },
  {
    id: 'vat-sales-tax-calculator',
    nameFr: 'Calculateur de TVA & Taxes de Vente Internationales',
    nameEn: 'Global VAT & Sales Tax Calculator',
    category: 'Everyday Consumer',
    description: 'Calcul instantané HT ↔ TTC et application des taux légaux de TVA/GST/Sales Tax par pays et catégories de biens.',
    inputs: ['Montant (HT ou TTC)', 'Pays', 'État / Province (si applicable)', 'Taux (Normal, Réduit, Super-réduit)'],
    outputs: ['Montant Hors Taxes (HT)', 'Montant de la Taxe', 'Montant TTC', 'Taux officiel appliqué'],
    dataSources: ['Directives fiscales nationales et étatiques'],
    refreshRate: 'Trimestriel',
    rulesetComplexity: 'Low',
    offlineCapability: true,
  },
  {
    id: 'tip-bill-split-calculator',
    nameFr: 'Calculateur de Pourboire & Partage d\'Addition',
    nameEn: 'Global Tip & Split Calculator',
    category: 'Everyday Consumer',
    description: 'Calcul des pourboires selon les normes culturelles locales (USA 15-22%, Europe service compris, Asie, etc.) et division équitable.',
    inputs: ['Total addition', 'Pays / Norme culturelle', '% Pourboire choisi', 'Nombre de personnes'],
    outputs: ['Montant pourboire total', 'Total avec pourboire', 'Montant exact par personne', 'Guide des usages culturels locaux'],
    dataSources: ['Base de données culturelle YamooPay'],
    refreshRate: 'Statique',
    rulesetComplexity: 'Low',
    offlineCapability: true,
  },
];

export const DATABASE_SCHEMA: DatabaseTable[] = [
  {
    name: 'users',
    category: 'Identity & Prefs',
    description: 'Comptes utilisateurs optionnels pour la sauvegarde des calculs et alertes de taux.',
    columns: [
      { name: 'id', type: 'UUID', nullable: false, isPrimary: true },
      { name: 'email', type: 'VARCHAR(255)', nullable: false, notes: 'Unique, indexed' },
      { name: 'password_hash', type: 'VARCHAR(255)', nullable: true, notes: 'Null si OAuth' },
      { name: 'role', type: 'VARCHAR(50)', nullable: false, notes: 'user | editor | admin | super_admin' },
      { name: 'email_verified_at', type: 'TIMESTAMPTZ', nullable: true },
      { name: 'created_at', type: 'TIMESTAMPTZ', nullable: false },
      { name: 'updated_at', type: 'TIMESTAMPTZ', nullable: false },
      { name: 'deleted_at', type: 'TIMESTAMPTZ', nullable: true, notes: 'Soft-delete pour conformité RGPD' },
    ],
    indexes: ['idx_users_email', 'idx_users_role'],
  },
  {
    name: 'user_preferences',
    category: 'Identity & Prefs',
    description: 'Préférences régionales, de devises et de confidentialité mémorisées.',
    columns: [
      { name: 'id', type: 'UUID', nullable: false, isPrimary: true },
      { name: 'user_id', type: 'UUID', nullable: false, isForeign: true, ref: 'users.id' },
      { name: 'default_country_code', type: 'VARCHAR(2)', nullable: false, notes: 'ISO 3166-1 alpha-2' },
      { name: 'default_currency_code', type: 'VARCHAR(3)', nullable: false, notes: 'ISO 4217' },
      { name: 'default_locale', type: 'VARCHAR(10)', nullable: false, notes: 'ex: en-US, fr-FR' },
      { name: 'consent_analytics', type: 'BOOLEAN', nullable: false },
      { name: 'consent_advertising', type: 'BOOLEAN', nullable: false },
      { name: 'updated_at', type: 'TIMESTAMPTZ', nullable: false },
    ],
    indexes: ['idx_user_preferences_user_id'],
  },
  {
    name: 'countries',
    category: 'Geo & Tax Rules',
    description: 'Référentiel mondial des pays, devises nationales et métadonnées SEO/fiscales.',
    columns: [
      { name: 'code', type: 'VARCHAR(2)', nullable: false, isPrimary: true, notes: 'US, GB, FR, CA, etc.' },
      { name: 'name_en', type: 'VARCHAR(100)', nullable: false },
      { name: 'name_fr', type: 'VARCHAR(100)', nullable: false },
      { name: 'default_currency', type: 'VARCHAR(3)', nullable: false, isForeign: true, ref: 'currencies.code' },
      { name: 'region_pack', type: 'VARCHAR(50)', nullable: false, notes: 'NorthAmerica | Europe | AsiaPacific | MiddleEast | LatinAmerica | Africa' },
      { name: 'wave', type: 'SMALLINT', nullable: false, notes: '1 to 5' },
      { name: 'is_active', type: 'BOOLEAN', nullable: false },
      { name: 'created_at', type: 'TIMESTAMPTZ', nullable: false },
    ],
    indexes: ['idx_countries_wave', 'idx_countries_region_pack', 'idx_countries_active'],
  },
  {
    name: 'tax_rulesets',
    category: 'Geo & Tax Rules',
    description: 'Ensembles de règles fiscales immuables et versionnées par juridiction et année fiscale.',
    columns: [
      { name: 'id', type: 'UUID', nullable: false, isPrimary: true },
      { name: 'country_code', type: 'VARCHAR(2)', nullable: false, isForeign: true, ref: 'countries.code' },
      { name: 'jurisdiction_code', type: 'VARCHAR(50)', nullable: false, notes: 'ex: US-CA, US-NY, CA-QC, CH-ZH, FR-ALL' },
      { name: 'tax_year', type: 'SMALLINT', nullable: false, notes: 'ex: 2026' },
      { name: 'version', type: 'INTEGER', nullable: false, notes: 'Version incrémentale' },
      { name: 'status', type: 'VARCHAR(20)', nullable: false, notes: 'draft | active | archived | superseded' },
      { name: 'rules_payload', type: 'JSONB', nullable: false, notes: 'Brackets, allowances, social contributions schema' },
      { name: 'official_source_url', type: 'TEXT', nullable: false },
      { name: 'verified_at', type: 'TIMESTAMPTZ', nullable: false },
      { name: 'verified_by_user_id', type: 'UUID', nullable: false, isForeign: true, ref: 'users.id' },
      { name: 'effective_from', type: 'DATE', nullable: false },
      { name: 'effective_to', type: 'DATE', nullable: true },
    ],
    indexes: ['idx_tax_rulesets_lookup (country_code, jurisdiction_code, tax_year, status)', 'idx_tax_rulesets_jsonb (rules_payload USING gin)'],
  },
  {
    name: 'exchange_rates_snapshots',
    category: 'Forex & Transfers',
    description: 'Historique des taux de change interbancaires pour calculs, graphiques et audit.',
    columns: [
      { name: 'id', type: 'BIGSERIAL', nullable: false, isPrimary: true },
      { name: 'base_currency', type: 'VARCHAR(3)', nullable: false, notes: 'ex: USD' },
      { name: 'target_currency', type: 'VARCHAR(3)', nullable: false, notes: 'ex: EUR' },
      { name: 'mid_market_rate', type: 'NUMERIC(18, 8)', nullable: false },
      { name: 'source_name', type: 'VARCHAR(50)', nullable: false, notes: 'ECB | Fed | Interbank Feed' },
      { name: 'captured_at', type: 'TIMESTAMPTZ', nullable: false },
    ],
    indexes: ['idx_fx_pair_time (base_currency, target_currency, captured_at DESC)'],
  },
  {
    name: 'transfer_providers',
    category: 'Forex & Transfers',
    description: 'Fournisseurs mondiaux et régionaux de transfert d\'argent avec scoring transparent.',
    columns: [
      { name: 'id', type: 'UUID', nullable: false, isPrimary: true },
      { name: 'slug', type: 'VARCHAR(50)', nullable: false, notes: 'wise, western-union, remitly, etc.' },
      { name: 'name', type: 'VARCHAR(100)', nullable: false },
      { name: 'logo_url', type: 'VARCHAR(255)', nullable: false },
      { name: 'provider_type', type: 'VARCHAR(30)', nullable: false, notes: 'global | regional_pack' },
      { name: 'is_active', type: 'BOOLEAN', nullable: false },
      { name: 'affiliate_link_template', type: 'TEXT', nullable: true },
      { name: 'disclosure_type', type: 'VARCHAR(30)', nullable: false, notes: 'none | affiliate | partner | sponsored' },
    ],
    indexes: ['idx_transfer_providers_slug', 'idx_transfer_providers_type'],
  },
  {
    name: 'transfer_quotes',
    category: 'Forex & Transfers',
    description: 'Devis réels horodatés par corridor et méthode pour une comparaison impartiale.',
    columns: [
      { name: 'id', type: 'UUID', nullable: false, isPrimary: true },
      { name: 'provider_id', type: 'UUID', nullable: false, isForeign: true, ref: 'transfer_providers.id' },
      { name: 'source_country', type: 'VARCHAR(2)', nullable: false },
      { name: 'target_country', type: 'VARCHAR(2)', nullable: false },
      { name: 'send_amount', type: 'NUMERIC(14, 2)', nullable: false },
      { name: 'send_currency', type: 'VARCHAR(3)', nullable: false },
      { name: 'received_amount', type: 'NUMERIC(14, 2)', nullable: false },
      { name: 'received_currency', type: 'VARCHAR(3)', nullable: false },
      { name: 'fixed_fee', type: 'NUMERIC(10, 2)', nullable: false },
      { name: 'fx_rate_applied', type: 'NUMERIC(18, 8)', nullable: false },
      { name: 'fx_markup_percent', type: 'NUMERIC(6, 4)', nullable: false },
      { name: 'delivery_speed_hours', type: 'NUMERIC(6, 2)', nullable: false },
      { name: 'user_value_score', type: 'NUMERIC(4, 2)', nullable: false, notes: '1.00 to 10.00 basé uniquement sur coût et vitesse' },
      { name: 'captured_at', type: 'TIMESTAMPTZ', nullable: false },
    ],
    indexes: ['idx_quotes_corridor (source_country, target_country, send_amount, captured_at DESC)'],
  },
  {
    name: 'audit_logs',
    category: 'Governance & Analytics',
    description: 'Traçabilité complète des modifications de règles fiscales, sources et opérations admin.',
    columns: [
      { name: 'id', type: 'UUID', nullable: false, isPrimary: true },
      { name: 'actor_user_id', type: 'UUID', nullable: true, isForeign: true, ref: 'users.id' },
      { name: 'action', type: 'VARCHAR(100)', nullable: false, notes: 'TAX_RULE_UPDATED, SOURCE_FAILED, etc.' },
      { name: 'entity_name', type: 'VARCHAR(50)', nullable: false },
      { name: 'entity_id', type: 'VARCHAR(100)', nullable: false },
      { name: 'old_data', type: 'JSONB', nullable: true },
      { name: 'new_data', type: 'JSONB', nullable: true },
      { name: 'ip_address', type: 'VARCHAR(45)', nullable: true },
      { name: 'created_at', type: 'TIMESTAMPTZ', nullable: false },
    ],
    indexes: ['idx_audit_logs_created_at', 'idx_audit_logs_entity (entity_name, entity_id)'],
  },
];

export const DATABASE_TABLES = DATABASE_SCHEMA;

export const SYSTEM_METRICS = {
  totalModules: 18,
  totalCountries: 35,
  targetCurrencies: 170,
  targetCorridors: 120,
  taxRulesVersion: '2026.1-PROD',
  complianceStandard: 'SOC2-TypeII & GDPR',
};

export { DELIVERABLES_P10 } from './monetizationData';
export { DELIVERABLES_P11 } from './analyticsData';

